import { AnimatedRedirect } from './AnimatedRedirect';

export default AnimatedRedirect;